// extracted by mini-css-extract-plugin
module.exports = {"arrow_next":"jagRA3BgCR32 _2vBwtdG-uQJo","arrow_prev":"_2J-iAfxvPuEz"};